import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { ResponseLoginInterface } from '../interfaces/auth.interface';
import { of } from 'rxjs';
import { requestError, requestSuccess } from '../store/change-password/actions';

@Injectable({
  providedIn: 'root',
})
export class CookieCustomService {
  public expireDate: Date = new Date(
    new Date().getTime() + 24 * 60 * 60 * 1000
  ); //next Day
  constructor(private cookieService: CookieService) {}

  public getItem(name: string): string | null {
    if (
      [environment.adminToken].indexOf(name) !== -1 ||
      [environment.frontToken].indexOf(name) !== -1
    ) {
      return this.cookieService.get(name);
    }
    return localStorage.getItem(name);
  }

  public setItem(name: string, value: string, expiredAd: number | null = null) {
    this.setExpireCookieDate();
    if (
      [environment.adminToken].indexOf(name) !== -1 ||
      [environment.frontToken].indexOf(name) !== -1
    ) {
      const expired = expiredAd ? new Date(expiredAd * 1000) : this.expireDate;
      this.cookieService.set(
        name,
        value,
        expired,
        '/',
        window.location.hostname,
        false,
        'Strict'
      );
    } else {
      localStorage.setItem(name, value);
    }
  }

  public async clear(admin: boolean = false): Promise<boolean> {
    await localStorage.removeItem('entity_' + environment.frontToken);
    await this.cookieService.delete(environment.frontToken);
    return admin;
  }

  public clearAdmin() {
    localStorage.clear();
    this.cookieService.deleteAll();
  }

  private setExpireCookieDate() {
    const ttl = parseInt(this.cookieService.get('ttl'));
    if (ttl && !isNaN(ttl)) {
      this.expireDate = new Date(new Date().getTime() + ttl * 1000);
    }
  }

  updateAuthCookie(data: ResponseLoginInterface) {
    let response = null;

    if (data.response) {
      response = { ...data.response };
      response.role = data.response.user.role;

      let expiredAt = ((new Date().getTime() / 1000) | 0) + response.ttl;
      this.setItem(environment.frontToken, response.id, expiredAt);
      this.setItem(
        'entity_' + environment.frontToken,
        JSON.stringify(response)
      );
    }
  }
}
